import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DIR_RTL } from "../../../constants/ThemeConstant";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { Button, Divider, Skeleton } from "antd";
import { CalendarOutlined, EnvironmentFilled, UserOutlined } from "@ant-design/icons";
import { checkOrder, makeOrder, updateDataState, getOrderCheckStatus, changePromotionsQuantity } from "redux/actions";
import SkeletonInput from "antd/lib/skeleton/Input";
import "./style.css";

const CheckOutFour = () => {
    const { 
        theme: { direction, locale }, 
        fetchedData: {storeData, makeOrderResult, checkedOrderData, orderCheckStatus},
        cartData: {homePromotion},
    } = useSelector(state => state);
    const history = useHistory();
    const dispatch = useDispatch();
    const [orderTotal, setOrderTotal] = useState(0);
    const [promotions, setPromotions] = useState(0)

    const search = useLocation().search;
    const orderId = new URLSearchParams(search).get('orderId');
    const orderStatusId = new URLSearchParams(search).get('code');
    const orderStatusPhone = new URLSearchParams(search).get('phone');
    const currency = storeData?.currency?.name ? storeData?.currency.name : "KWD";
    const selected_mode = localStorage.getItem('selected-mode');
    
    const [data, setData] = useState({})

    const styleIcon = {
        fontSize: "21px",
    }

    useEffect(() => {

    }, []);

    useEffect(() => {
        setData(orderCheckStatus);
        setOrderTotal(orderCheckStatus?.products?.reduce((acc, cur) => acc + (cur.price * cur.count), 0));
    }, [orderCheckStatus])


    useEffect(()=>{
        window.scrollTo({top:0, behavior: 'auto'});
        if (localStorage.getItem('applied-voucher')){
            dispatch(changePromotionsQuantity(JSON.parse(localStorage.getItem('applied-voucher'))))
        }else{
            dispatch(changePromotionsQuantity({}))
        }

        if (orderStatusId && orderStatusPhone) {
            dispatch(getOrderCheckStatus(`?code=${orderStatusId}&phone=${orderStatusPhone}`));
        }else if (orderId){
            dispatch(checkOrder(orderId))
        }else{
            setData({
                userData: {
                    ...JSON.parse(localStorage.getItem('contactInformation')),
                    ...JSON.parse(localStorage.getItem('deliveryInfo'))
                },
                products: JSON.parse(localStorage.getItem('cart')),
                timings: JSON.parse(localStorage.getItem('fulfillment-time')),
                timingDate: JSON.parse(localStorage.getItem('fulfillment-time'))?.day?.date,
                deliveryArea: localStorage.getItem('selected-mode') === 'delivery' ? 
                    JSON.parse(localStorage.getItem('selected-area')) : 
                    JSON.parse(localStorage.getItem('selected-branch')),
                payType: localStorage.getItem('payType'),
                timing: JSON.parse(localStorage.getItem('fulfillment-time'))?.time,
            })
        }
        return ()=>{
            dispatch(updateDataState({makeOrderResult:{}}))
        }
    }, [])

   useEffect(()=>{
        if (orderId || orderStatusId){
            setData(checkedOrderData)
        }
        console.log(checkedOrderData)
    }, [checkedOrderData])

    useEffect(()=>{
        if (homePromotion?.minimumPurchase <= (subTotal+taxPrice+((!homePromotion?.freeDelivery && delivery)))){
            if (homePromotion?.discountType === 'AMOUNT'){
                setPromotions(homePromotion.amount)
            }else{
                setPromotions((subTotal+taxPrice+(!homePromotion?.freeDelivery && delivery))*homePromotion.amount/100)
            }
        }
    }, [homePromotion])

    const {products, timings, deliveryArea, userData, timingDate, timing, payType, orderTimeType} = data

    const subTotal = data?.products?.reduce((acc, cur) => acc + (cur.price * cur.quantity), 0);
    const taxPrice = data?.products?.reduce((acc, cur) => acc + cur.taxPrice, 0);
    // const delivery = data?.products?.reduce((acc, cur) => acc + (cur.taxPrice), 0);

    const delivery = 3;

    const order = () => {
        if (orderId || orderStatusId){
            window.history.back();
        }else{
            dispatch(makeOrder({
                "timing": timings?.type === 'Scheduled Order' ? JSON.parse(localStorage.getItem('fulfillment-time'))?.time.id : '',
                deliveryArea: deliveryArea?.id,
                orderTimeType: timings?.type === 'As Soon as Possible' ? 'AS_SOON_AS_POSSIBLE' : timings?.type?.includes('Custom') ? 'CUSTOM_DELIVERY' : 'SCHEDULE_ORDER',
                "date": {
                    ...timing, 
                    day: timings?.day?.day?.toUpperCase(), 
                },
                timingDate,
                customDeliveryText: timings?.type?.includes('Custom') && timings?.type?.slice(18),
                "itemsPrice": subTotal,
                "totalPrice": subTotal+(!homePromotion?.freeDelivery && selected_mode === 'pickup' ? 0 : deliveryArea?.template?.deliveryFee)+taxPrice-promotions,
                "payType": localStorage.getItem('payType')==='cash' ? 'CASH' : localStorage.getItem('payType')==='k-net' ? 'KNET' : 'CARD',
                "promotionId": "",
                taxCharges:taxPrice,
                "status": localStorage.getItem('selected-mode')==='delivery' ? 'DELIVERY' : 'PICKUP',
                userData:{
                    "avenue": userData?.avenue,
                    "block": userData?.block,
                    "building": userData?.building,
                    "email": userData?.email,
                    "floor": userData?.floor,
                    "house": userData?.house,
                    "name": userData?.name,
                    "payType": localStorage.getItem('payType')==='cash' ? 'CASH' : localStorage.getItem('payType')==='knet' ? 'KNET' : 'CARD',
                    "phone": userData?.phone,
                    "special": userData?.special,
                    "street": userData?.street,
                    "officeNo": userData?.officeNo,
                    "apartmentNo": userData?.apartmentNo,
                    "unitType": userData?.unitType==='office' ? 'OFFICE' : userData?.unitType==='home' ? 'HOUSE' : 'APARTMENT',
                },
                products,
            }))
        }
    }

    useEffect(()=>{
        if (!orderId){
            if (makeOrderResult?.payLink){
                window.open(makeOrderResult?.payLink, "_self")
            }else if (makeOrderResult?.orderId){
                history.push(`${APP_PREFIX_PATH}/check_order?orderStatus=${makeOrderResult?.orderId}&phone=${userData?.phone}`)  
            } 
        }
    }, [makeOrderResult])

    const skeleton = (width, height) => {
        return <SkeletonInput active style={{width: width, height: height}}/>
    }

    console.log(timings);

    return (
        <div className="checkOut-page-style">
            <div className="checkOutNav" style={{ borderBottom: "1px solid grey" }}>
                <div onClick={() => window.history.back()}>
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0} style={{ fontSize: '24px', cursor: 'pointer', color: 'black' }} />
                </div>
                <div className='text-center w-100' style={{ fontSize: "17px", color: '#000', fontWeight: '600' }}>Order Details</div>
            </div>

            <div className="checkOut-content p-2">
                <h4 style={{color: '#000'}}> Order items </h4>
                <Divider className='my-2' />
                {products?.length>0 ? products?.map(item => <div key={item?.id} className="d-flex justify-content-between align-items-center text-muted pl-2 pr-2">
                    <p> {orderId || orderStatusId ? item?.count : item?.quantity}x {locale==='en' ? item?.product?.nameEng : item?.product?.nameAr} </p>
                    <p> {(orderId || orderStatusId ? item?.totalPrice : item?.itemTotal)?.toFixed(3)} {storeData?.currency?.name ? storeData?.currency.name : "KWD"} </p>
                </div>) : <Skeleton active/>}
                
                <Divider className='my-2' />
                <h4 style={{color: '#000'}}> Delivery info </h4>
                <div className="pl-2 pr-2">
                    <p className="d-flex align-items-center">
                        <CalendarOutlined style={styleIcon} />
                        <p className="m-0 ml-2">
                            {orderTimeType === "AS_SOON_AS_POSSIBLE" || timings?.type === "As Soon as Possible" ? "As Soon as Possible" :
                            orderTimeType === "CUSTOM_DELIVERY" ? data?.customDeliveryText : timings?.type?.includes('Custom') ? timings?.type?.slice(18) :
                            <span>
                                {timingDate ?? skeleton(60, 20)} - {timing?.openingTime ?? skeleton(70, 20)} - {timing?.closingTime ?? skeleton(60, 20)} 
                            </span>
                            }
                        </p>
                    </p>
                    <Divider className='my-2' />
                    <div className="d-flex align-items-center">
                        <EnvironmentFilled style={styleIcon} />
                        {userData ? <p className="m-0 ml-2">
                            {locale==='en'?  deliveryArea?.nameEng : deliveryArea?.nameAr}<br/>
                            {selected_mode === 'pickup' ? 
                            <>
                                address: {locale==='en' ? deliveryArea?.addressEng : deliveryArea?.addressAr },
                                phone: {deliveryArea?.phone}

                            </> :
                            <>
                                {userData?.block && `Block: ${userData?.block}`}
                                {userData?.street && `, Street: ${userData?.street}`} 
                                {userData?.avenue && `, Avenue: ${userData?.avenue}`} 
                                {userData?.building && `, Building: ${userData?.building}`} 
                                {userData?.floor && `, Floor: ${userData?.floor}`} 
                                {userData?.apartmentNo && `, Apartment No: #${userData?.apartmentNo}`}
                                {userData?.officeNo && `, Office No: #${userData?.officeNo}`}
                                {userData?.house && `, House No: #${userData?.house}`}
                                {userData?.special && `, Special Directions: ${userData?.special}`}
                            </>}
                        </p> : skeleton(320, 60)}
                    </div>
                    <Divider className='my-2' />
                    <div className="d-flex align-items-center">
                        <UserOutlined style={styleIcon} />
                        <div className="m-0 ml-2"> 
                            {userData?.name ? <>
                                <div>{userData?.name || 'user name'}</div>
                                <div>{userData?.phone || 'phone number'}</div>
                            </> : skeleton(100, 40)}
                        </div>
                    </div>
                </div>
                <Divider className='my-2' />
                <h4 style={{color: '#000'}}> Payment Methods </h4>
                <div className="pb-2 px-2">
                    {
                        payType ? <p className="m-0" style={{textTransform: 'uppercase'}}> {payType} </p> : skeleton(60, 24)
                    }
                    <Divider className='my-2' />
                    {selected_mode === 'pickup' ? '' :
                    <div className="d-flex justify-content-between align-items-center ">
                        <div> Delivery </div>
                        {deliveryArea?.template?.deliveryFee ? <div> {storeData?.currency?.name ?? "KWD"} {(deliveryArea?.template?.deliveryFee || 0)?.toFixed(3)}</div> : skeleton(50, 20)}
                    </div>}
                    <div className='d-flex align-items-center justify-content-between'>
                        <div>Tax</div>
                        <div>{storeData?.currency?.name ? storeData?.currency.name : "KWD"} {(orderId||orderStatusId ? data?.taxCharges : taxPrice)?.toFixed(3)}</div>
                    </div>
                    {homePromotion?.id && <div className=' mt-2 d-flex align-items-center justify-content-between'>
                        <div>Voucher Discount</div>
                        <div>{currency} {promotions.toFixed(3)}</div>
                    </div>}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <h3 style={{color: '#000'}}> Total </h3>
                    {data?.totalPrice || subTotal ? <h3 style={{color: '#000'}}>
                            {(storeData?.currency?.name+' ') ?? "KWD "} 
                            {( orderId || orderStatusId ? data?.totalPrice : (subTotal+(!homePromotion?.freeDelivery && selected_mode === 'pickup' ? 0 : deliveryArea?.template?.deliveryFee)+taxPrice-promotions))?.toFixed(3)} 
                        </h3> : skeleton(130, 30)}
                </div>
            </div>
            <div className='orderCheckoutContainer branch-btn'>
                <Button onClick={() => order()} className={`w-100 orderCheckout btn-project primaryColor`}>
                    {orderId || orderStatusId ? 'Back' : 'Next'}
                </Button>
            </div>
        </div>
    )
}

export default CheckOutFour;